import React from "react";
import { useEffect } from "react";
import { Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import { setActiveCategoryInNav } from "@/store/ui/ui";
import { RootState } from "@/store/store";
import NavigationMenu from "./NavigationMenu";
import useGetRole from "@/hooks/useGetRole";

import { navigationItems } from "@/utils/constants";

import "./Navigation.scss";

function Navigation() {
    const activeCategoryInNav = useSelector(
        (state: RootState) => state.ui.activeCategoryInNav,
    );
    const { isAdmin } = useGetRole();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const pathSegments = location.pathname.split("/").filter(Boolean);
        const category = pathSegments[0];
        if (category) {
            dispatch(setActiveCategoryInNav(category));
        }
    }, [dispatch, location.pathname]);

    const filteredNavigationItems = navigationItems.filter(item => {
        if (isAdmin) return true;
        return (
            item.id !== "users" &&
            item.id !== "statistic" &&
            item.id !== "services"
        );
    });

    return (
        <nav className='navigation_container'>
            <Link className='navigation_logo' to={"/schedule"}>
                <img
                    className='logo_in_nav'
                    src='/navigation/main-logo.png'
                    alt='logo-in-nav'
                />
            </Link>
            <ul className='navigation_list'>
                {filteredNavigationItems.map(item => (
                    <li
                        key={item.id}
                        className={`navigation_item  ${
                            activeCategoryInNav === item.id ? "isActive" : ""
                        } `}
                    >
                        <Link to={`/${item.id}`} className='navigation_link'>
                            <div
                                className={`navigation_icon_container ${
                                    item.id
                                } ${
                                    activeCategoryInNav === item.id
                                        ? `${item.id}_active`
                                        : ""
                                }`}
                            />
                            <p className='navigation_subTitle'>{item.title}</p>
                        </Link>
                    </li>
                ))}
            </ul>
            <NavigationMenu />
        </nav>
    );
}
export default React.memo(Navigation);
